import { useState, useEffect } from 'react'

import Api from 'services/api'

const useAwairEvents = (deviceId, date, timeZone, requestTime, awairDeviceId) => {
  const [awairEvents, setAwairEvents] = useState(null)
  const [thermostatEvents, setThermostatEvents] = useState(null)
  const [displayIndoorUnit, setDisplayIndoorUnit] = useState(false)
  const [areAwairEventsLoaded, setAreAwairEventsLoaded] = useState(false)
  const [serverErrorOccurred, setServerErrorOccurred] = useState(false)

  useEffect(() => {
    // for subsequent calls we need to reset back to no data
    setThermostatEvents(null)
    setDisplayIndoorUnit(false)
    setAwairEvents(null)
    setAreAwairEventsLoaded(false)
    setServerErrorOccurred(false)

    if (!awairDeviceId) return

    Api.AwairEvents.list(deviceId, awairDeviceId, date, timeZone)
      .then((res) => {
        if (res.awairEvents) {
          setAreAwairEventsLoaded(true)
          setThermostatEvents(res.thermostatEvents)
          setDisplayIndoorUnit(res.displayIndoorUnit)
          setAwairEvents(res.awairEvents)
        }
      })
      .catch(() => {
        setAreAwairEventsLoaded(true)
        setThermostatEvents(null)
        setAwairEvents(null)
        setServerErrorOccurred(true)
      })
  }, [deviceId, awairDeviceId, date, timeZone, requestTime])

  return { awairEvents, thermostatEvents, displayIndoorUnit, areAwairEventsLoaded, serverErrorOccurred }
}

export default useAwairEvents
